import { render, staticRenderFns } from "./CollaspsePannel.vue?vue&type=template&id=42073a8e&scoped=true&"
import script from "./CollaspsePannel.vue?vue&type=script&lang=js&"
export * from "./CollaspsePannel.vue?vue&type=script&lang=js&"
import style0 from "./CollaspsePannel.vue?vue&type=style&index=0&id=42073a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42073a8e",
  null
  
)

export default component.exports